/*
  Held apart from `Accordions.tsx` because they are values rather than types: the group's context
  reads one of them for its own default, and importing a value back out of `Accordions.tsx` closes
  a require cycle that leaves the enum undefined at module-evaluation time.
*/

export enum AccordionShadow {
  DEFAULT = 'default',
  ELEVATED = 'elevated',
}

/*
  How far the marker turns between shut and open, which is also what says a section should be eased
  rather than swapped. A quarter turn suits a marker that rests pointing along the run - right, then
  down into the section it opened. A half turn suits one that rests pointing at the section itself,
  and turns to point back at its heading.
*/
export enum AccordionRotation {
  QUARTER = '90',
  HALF = '180',
}

/*
  Where the marker sits in the heading's row. `end` puts it against the far edge, which lines every
  marker in a run up whatever its heading says; `beside` keeps it with the words, which reads as one
  thing to click rather than two ends of a bar.
*/
export enum AccordionIconPosition {
  BESIDE = 'beside',
  END = 'end',
}
